import { aPackagePickerEventSelectCycle, packagePickerCycleSelection2ndStepClickContinueToCheckoutSrc17Evid3925, platformizedPackagePickerCycleSavingTooltipHoverSrc17Evid2263, platformizedPackagePickerDisabledCycleSelectorTooltipShowSrc17Evid2262, platformizedPackagePickerSelectCyclePageClickOnMonthlySectionHelperLinkSrc17Evid2242, platformizedPackagePickerSelectCyclePageLoadSrc17Evid2248 } from '@wix/bi-logger-premium-data/v2';
import { BiUtils, CycleUtils } from '@wix/package-picker-shared';
import React from 'react';
import { useCurrentModule } from '../../components';
import { useBiLogger } from './useBiLogger';
import { useCommonBiEventsFields } from './useCommonBiEventsFields';
import { useInitGeneralBiEvents } from './useInitGeneralBiEvents';
export const useInitSelectCyclePageBiEvents = () => {
  const [didInit, setDidInit] = React.useState(false);
  const module = useCurrentModule();
  const {
    setBiEvent
  } = module.SDK;
  const {
    biLogger
  } = useBiLogger();
  useInitGeneralBiEvents();
  const {
    commonBiEventsFields,
    isLoading: isCommonBiEventsFieldsLoading
  } = useCommonBiEventsFields();
  const selectedCycleId = module.SDK.PackagePickerStore.useSelectedCycleId();
  const biCycle = BiUtils.getBiCycle(CycleUtils.convertCycleIdToCycle(selectedCycleId));
  const selectedProductId = module.SDK.PackagePickerStore.useSelectedProductId() || undefined;
  const isLoading = isCommonBiEventsFieldsLoading;
  React.useEffect(() => {
    if (isLoading) {
      return;
    }
    setBiEvent('onSelectCyclePageLoad', () => {
      const additionalFields = {
        cycleid: biCycle || undefined,
        productGuid: selectedProductId
      };
      biLogger == null || biLogger.report(
      // 17:2248
      platformizedPackagePickerSelectCyclePageLoadSrc17Evid2248({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onSelectCycle', _ref => {
      let {
        cycle,
        productId
      } = _ref;
      const additionalFields = {
        cycle: BiUtils.getBiCycle(cycle),
        productGuid: productId || undefined
      };
      biLogger == null || biLogger.report(
      // 17:3906
      aPackagePickerEventSelectCycle({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onContinueToCheckoutClick', () => {
      const additionalFields = {
        cycleid: biCycle || undefined,
        productGuid: selectedProductId
      };
      biLogger == null || biLogger.report(
      // 17:3925
      packagePickerCycleSelection2ndStepClickContinueToCheckoutSrc17Evid3925({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onMonthlyCycleSectionHelperLinkClick', _ref2 => {
      let {
        action
      } = _ref2;
      const additionalFields = {
        action,
        productGuid: selectedProductId
      };
      biLogger == null || biLogger.report(
      // 17:2242
      platformizedPackagePickerSelectCyclePageClickOnMonthlySectionHelperLinkSrc17Evid2242({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onCycleSelectorTooltipShow', _ref3 => {
      let {
        cycle,
        key
      } = _ref3;
      const additionalFields = {
        cycleName: cycle ? CycleUtils.convertCycleToCycleId(cycle) : undefined,
        tooltipKey: key ?? undefined
      };
      biLogger == null || biLogger.report(
      // 17:2262
      platformizedPackagePickerDisabledCycleSelectorTooltipShowSrc17Evid2262({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setBiEvent('onCycleSavingTooltipHover', _ref4 => {
      let {
        content
      } = _ref4;
      const additionalFields = {
        content
      };
      biLogger == null || biLogger.report(
      // 17:2263
      platformizedPackagePickerCycleSavingTooltipHoverSrc17Evid2263({
        ...commonBiEventsFields,
        ...additionalFields
      }));
    });
    setDidInit(true);
  }, [setBiEvent, biLogger, isLoading, commonBiEventsFields, biCycle, selectedProductId]);
  return {
    didInit
  };
};
//# sourceMappingURL=useInitSelectCyclePageBiEvents.js.map